/**
 * Retour d'un écran Skipcar+ joignable depuis plusieurs endroits (profils de
 * taux, simulation, contrat) : l'écran d'origine se passe en `state` du lien,
 * au lieu d'un parent codé en dur.
 */
export interface CheminRetour {
  vers: string;
  libelle: string;
}

export const lireRetour = (state: unknown): CheminRetour | null => {
  const candidat = state as Partial<CheminRetour> | null | undefined;
  return typeof candidat?.vers === 'string' && candidat.vers.startsWith('/') && typeof candidat.libelle === 'string'
    ? { vers: candidat.vers, libelle: candidat.libelle }
    : null;
};
